/* unplugin-vue-components disabled */import { render } from "./announcementTemplate.vue?vue&type=template&id=933ea228&scoped=true"
import script from "./announcementTemplate.vue?vue&type=script&lang=js"
export * from "./announcementTemplate.vue?vue&type=script&lang=js"

import "./announcementTemplate.vue?vue&type=style&index=0&id=933ea228&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-933ea228"]])

export default __exports__